/**
 * Date/label helpers shared across the Supervisor Panel views.
 *
 * Kept as plain functions (no React) so any component in
 * ``components/supervisor/*`` can pull them without a circular import.
 */

export const PLAN_BADGE = {
  basic: "bg-slate-700 text-slate-200",
  premium: "bg-blue-700 text-blue-100",
  enterprise: "bg-purple-700 text-purple-100",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("el-GR") + " " + d.toLocaleTimeString("el-GR", { hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function fmtRelative(iso) {
  if (!iso) return "Ποτέ";
  try {
    const sec = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
    if (sec < 60) return `${sec}s πριν`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} λεπτ. πριν`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} ώρες πριν`;
    const d = Math.floor(hr / 24);
    return `${d} ημ. πριν`;
  } catch { return "—"; }
}

export function daysUntil(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}
